import { render, staticRenderFns } from "./searchResults.vue?vue&type=template&id=89a01c7a"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports